<template>
    <v-navigation-drawer v-model="drawer" temporary location="left" width="400" color="#f1f1f1">
        <v-card tile color="transparent" class="overflow-visible">
            <v-toolbar color="white" elevation="1" class="position-sticky py-1 top-0" style="z-index: 2;">
                <template v-slot:prepend>
                    <v-btn @click="drawer = false" color="primary" icon="close"></v-btn>
                </template>
                <v-toolbar-title class="text-primary">{{ title }}</v-toolbar-title>
            </v-toolbar>
            <div class="mt-3 px-2">
                <div class="py-2 px-3 mb-3 rounded bg-white" v-for="item in customFields">
                    <div class="d-flex align-center ga-3">
                        <v-icon size="20" class="pa-4 rounded" color="primary" style="background-color:#cae2fe">{{ $system.customfieldTypes[item.type].icon }}</v-icon>
                        <p class="text-small text-primary font-weight-bold">{{ getLabel(item) }}</p>
                    </div>
                    <a :href="getValue(item)" target="_blank" v-if="item.type == 'url'" class="text-small text-grey-darken-1 mt-2 mb-n1">{{ getValue(item) }}</a>
                    <p v-else class="text-small text-grey-darken-1 mt-2 mb-n1">{{ getValue(item) }}</p>
                </div>
            </div>
        </v-card>
    </v-navigation-drawer>
</template>
<script>
export default {
    props: {
        customFields: {
            required: true,
            default: () => [],
        },
        title: {
            type: String,
            default: 'اطلاعات تکمیلی',
        },
    },
    data() {
        return {
            drawer: false,
        };
    },
    methods: {
        getLabel(item) {
            let label = item.label ?? item.options.label;
            return label.length > 45 ? label.slice(0,45) + '.....' : label;
        },
        getValue(item) {
            if (item.type === "checkbox")
                return item.value == 0 ? 'خیر' : 'بله';
            if (item.type == 'date')
                return item.value ? this.$moment(item.value, 'X').format(item.options.type == 'time' ? 'HH:mm' : item.options.type == 'datetime' ? 'jYYYY-jMM-jDD HH:mm' : 'jYYYY-jMM-jDD') : null;
            return item.value;
        },
    },
};
</script>
